import type { JSX } from "react";

import type { ISwitcherConfig } from "app/components/React/WidgetContainer/types";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import type { IFooterButton } from "app/components/React/WidgetContainer/WidgetFooter";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { translate } from "app/filters/i18nFilter";
import type { Filter } from "pro-features/components/BoxSubtitle/src/BoxSubtitle";

import { FooterWrapperComponent } from "./styledComponents";

interface GenericWidgetSearchOverviewProps {
    title: string;
    tooltip: string;
    children: React.ReactNode;
    footerButtonsConfig?: IFooterButton[];
    subtitleFilters?: Filter[];
    switcherConfig?: ISwitcherConfig;
    minHeight?: number;
    descriptionText?: JSX.Element;
}
const GenericWidgetSearchOverview: React.FC<GenericWidgetSearchOverviewProps> = ({
    title,
    tooltip,
    footerButtonsConfig,
    subtitleFilters: subtitleFiltersProp,
    minHeight,
    switcherConfig,
    children,
    descriptionText,
}) => {
    const defaultSubtitleFilters = useSubtitleFilters("date", "country", "webSource");
    const subtitleFilters = subtitleFiltersProp || defaultSubtitleFilters;

    return (
        <WidgetContainer
            withBorder
            title={translate(title)}
            tooltip={translate(tooltip)}
            subtitleFilters={subtitleFilters}
            footerButtonsConfig={footerButtonsConfig}
            bodyHeight="auto"
            footerWrapperComponent={FooterWrapperComponent}
            height="100%"
            minHeight={minHeight}
            switcherConfig={switcherConfig}
            descriptionText={descriptionText}
        >
            {children}
        </WidgetContainer>
    );
};

export default GenericWidgetSearchOverview;
